import React, { useState } from 'react';
import AuthPageLayout from '../../shared/ui/auth-page-layout/AuthPageLayout';
import Button from '../../shared/ui/button/Button';
import s from './ResetPasswordPage.module.css';
import { useAppDispatch } from '../../store/store';
import { resetPassword } from '../../shared/api/authApi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsLoading, selectErrors } from '../../store/selectors/authSelectors';
const ResetPasswordPage: React.FC = () => {
    const loading = useSelector(selectIsLoading);
    const errors = useSelector(selectErrors);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [error, setError] = useState('');
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const email = searchParams.get('email');
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!newPassword) {
            setError('Password is required');
            return;
        }
        if (newPassword.length < 8) {
            setError('Password must be at least 8 characters');
            return;
        }
        if (!/(?=.*[0-9])(?=.*[a-zA-Z])/.test(newPassword)) {
            setError('Password must contain at least one letter and one number');
            return;
        }
        if (newPassword !== repeatPassword) {
            setError('Passwords do not match');
            return;
        }

        const action = await dispatch(
            resetPassword({
                email: email || '',
                password: newPassword,
                password_confirmation: repeatPassword,
                token: token || '',
            }),
        );
        if (resetPassword.fulfilled.match(action)) {
            navigate('/auth');
        }
        console.log('newPassword', newPassword);
        console.log('repeatPassword', repeatPassword);
    };
    console.log('errors', errors);

    return (
        <AuthPageLayout>
            <div className={s.container}>
                <h2 className={s.title}>New password</h2>
                <p className={s.text}>
                    Please enter a new password for <b>{email}</b> account
                </p>
                <form
                    className={s.form}
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit(e);
                    }}
                >
                    <p className={s.input_text}>New password</p>
                    <input
                        className={s.input}
                        type="password"
                        placeholder="Type password here.."
                        value={newPassword}
                        onChange={(e) => {
                            setNewPassword(e.target.value);
                            setError('');
                        }}
                        required
                    />
                    <p className={s.input_text}>Re-type new password</p>
                    <input
                        className={`${s.input} ${error === 'Passwords do not match' ? s.input_error : ''}`}
                        type="password"
                        placeholder="Type password here.."
                        value={repeatPassword}
                        onChange={(e) => {
                            setRepeatPassword(e.target.value);
                            setError('');
                        }}
                        required
                    />
                    {error && <p className={s.error_text}>{error}</p>}
                    <Button
                        text={'Done'}
                        state={loading ? 'loading' : 'enabled'}
                        type="submit"
                        style={{ background: '#FFE100', width: '100%', marginTop: 24 }}
                    />
                </form>
            </div>
        </AuthPageLayout>
    );
};

export default ResetPasswordPage;
